var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar'),_c('Hero'),_c('Logos',{attrs:{"title":"Partners","logos":_vm.logos}}),_c('Stats',{staticClass:"mb-4"}),_c('Feature11',{staticClass:"pt-4"}),_c('CoursesJobsTease',{staticClass:"pb-4"}),_c('Feature8'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }